import { useTranslation } from 'react-i18next';
import { Button, Container, Stack, Text, Title } from '@mantine/core';
import { IconDownload } from '@tabler/icons-react';

type StaticDocKey = 'policy' | 'terms' | 'supply' | 'teo';

interface StaticDocPageProps {
  readonly docKey: StaticDocKey;
}

// Юридическая страница: заголовок + описание + скачивание PDF (ассет из public/docs/).
export default function StaticDocPage({ docKey }: StaticDocPageProps) {
  const { t } = useTranslation();
  const pdfUrl = `/docs/${docKey}.pdf`;

  return (
    <Container size="md" py="xl">
      <Stack gap="md" align="flex-start">
        <Title order={1}>{t(`static.${docKey}.title`)}</Title>
        <Text c="dimmed">{t(`static.${docKey}.desc`)}</Text>
        <Button
          component="a"
          href={pdfUrl}
          target="_blank"
          rel="noopener noreferrer"
          leftSection={<IconDownload size={18} />}
        >
          {t('static.download')}
        </Button>
      </Stack>
    </Container>
  );
}
